module.exports = __webpack_public_path__ + "img/factory.d230452a.svg";